import api from "@/api";


//列表
export const _page = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/page`, data)
}

//新增
export const _authGroupedit = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/edit`, data)
}


//删除
export const _authGrodelete = (data) => {
    return api.axss("get", `/ocm-admin/authGroup/delete`, data,data)
}



//编辑客户列表
export const _mobillist = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/group/consumer/list`, data)
}


//编辑客户
export const _consumerDit = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/group/consumer/edit`, data)
}




//编辑用户列表
export const _groupmobillist = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/group/mobil/list`, data)
}


//编辑用户
export const _groupconsumerDit = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/group/mobilUser/edit`, data)
}


//
export const editAuthGroup = (data) => {
    return api.axss("post", `/ocm-admin/authGroup/editAuthGroup`, data)
}
